/* Fathom Thread v1: trang giỏ (section ft-cart).
   Số lượng / xoá / món thêm bằng /cart/change.js + /cart/add.js, xong tải lại trang (giỏ luôn khớp server).
   Sửa dòng: chỉ đổi chữ → change.js cập nhật properties (giữ nguyên file logo, cập nhật _fathom để phí khớp);
   đổi size → thêm dòng mới (cùng properties) rồi mới xoá dòng cũ; lỗi giữa chừng thì báo, không nhân đôi. */
(function () {
  'use strict';
  if (window.FtCart) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(c) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Request failed'); return j; }); });
  }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { if (k === 'text') n.textContent = attrs[k]; else n.setAttribute(k, attrs[k]); });
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  function FtCart(root) {
    this.root = root; var self = this;
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-ftc-q]'), rm = e.target.closest('[data-ftc-remove]'), ed = e.target.closest('[data-ftc-edit]'), im = e.target.closest('[data-ftc-img]');
      if (q) self.qty(q.closest('[data-ftc-line]'), parseInt(q.getAttribute('data-ftc-q'), 10), q);
      else if (rm) self.change(rm.closest('[data-ftc-line]'), 0, rm);
      else if (ed) self.edit(ed.closest('[data-ftc-line]'), ed);
      else if (im) { var v = root.querySelector('[data-ftc-imgview]'); v.src = im.getAttribute('data-ftc-img'); window.FtSheet.open(root.querySelector('[data-ftc-imgsheet]'), im); }
    });
    root.querySelectorAll('[data-ftc-bump]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        cb.disabled = true;
        var p = cb.checked ? post('cart/add.js', { items: [{ id: parseInt(cb.getAttribute('data-ftc-bump'), 10), quantity: 1 }] }) : post('cart/change.js', { id: cb.getAttribute('data-key'), quantity: 0 });
        p.then(function () { location.reload(); }).catch(function (x) { cb.disabled = false; cb.checked = !cb.checked; alertInline(cb.closest('.ftc__bumps'), x.message); });
      });
    });
    // Thanh checkout dính (mobile): hiện khi nút checkout chính ra khỏi màn hình; bấm = bấm nút chính (một luồng).
    var bar = root.querySelector('[data-ftc-bar]'), main = root.querySelector('[data-ftc-checkout]');
    if (bar && main) {
      root.querySelector('[data-ftc-barbtn]').addEventListener('click', function () { main.click(); });
      if (window.IntersectionObserver) new IntersectionObserver(function (es) { es.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting); }); }).observe(main);
    }
    var co = root.querySelector('[data-ftc-checkout]');
    if (co) co.closest('form').addEventListener('submit', function () { co.setAttribute('aria-busy', 'true'); co.textContent = 'Going to checkout…'; });
  }
  function alertInline(near, msg) {
    var p = near.querySelector('.ftc__err') || near.appendChild(el('p', { class: 'ftc__err', role: 'alert' }));
    p.hidden = false; p.textContent = msg || 'Something went wrong. Please try again.';
  }
  FtCart.prototype.busy = function (line, on) { line.classList.toggle('is-busy', on); line.querySelectorAll('button,input').forEach(function (b) { b.disabled = on; }); };
  FtCart.prototype.qty = function (line, d, btn) { var q = parseInt(line.getAttribute('data-qty'), 10) + d; if (q < 1) return; this.change(line, q, btn); };
  FtCart.prototype.change = function (line, q, btn) {
    var self = this; this.busy(line, true);
    post('cart/change.js', { id: line.getAttribute('data-ftc-line'), quantity: q })
      .then(function () { location.reload(); })
      .catch(function (x) { self.busy(line, false); var e = line.querySelector('[data-ftc-err]'); e.hidden = false; e.textContent = x.message; });
  };

  /* ---------- sheet sửa dòng ---------- */
  // Thuộc tính dòng lấy từ /cart.js (giá trị gốc). Không đọc từ Liquid: properties | json ra mảng cặp và bị mã hoá HTML.
  FtCart.prototype.edit = function (line, opener) {
    var self = this;
    if (opener) opener.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (opener) opener.removeAttribute('aria-busy');
      var item = (cart.items || []).filter(function (i) { return i.key === line.getAttribute('data-ftc-line'); })[0];
      if (!item) { location.reload(); return; }
      self.openEdit(line, opener, item.properties || {});
    }).catch(function () { if (opener) opener.removeAttribute('aria-busy'); var e = line.querySelector('[data-ftc-err]'); e.hidden = false; e.textContent = 'Could not load this item. Please refresh the page.'; });
  };
  FtCart.prototype.openEdit = function (line, opener, props) {
    var self = this, sheet = this.root.querySelector('[data-ftc-sheet]'), body = sheet.querySelector('[data-ftc-sheet-body]');
    if (Array.isArray(props)) props = {};
    var variants = JSON.parse(line.querySelector('[data-ftc-variants]').textContent);
    var cfgEl = line.querySelector('[data-ftc-cfg]'), cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
    var sizePos = parseInt(line.getAttribute('data-size-pos'), 10) || 0;
    var cur = variants.filter(function (v) { return String(v.id) === line.getAttribute('data-variant'); })[0];
    var qty = parseInt(line.getAttribute('data-qty'), 10);
    var state = { variant: cur, vals: {} };
    body.innerHTML = '';
    var title = line.querySelector('.ftc__title').textContent, type = (line.querySelector('.ftc__type') || {}).textContent || '';
    var img = line.querySelector('.ftc__img img');
    body.appendChild(el('div', { class: 'ftc-e__prod' }, [img ? el('img', { src: img.currentSrc || img.src, alt: '', width: '72', height: '72' }) : null, el('div', {}, [el('b', { text: title }), el('span', { text: type })])]));

    // size
    if (sizePos && cur) {
      body.appendChild(el('h3', { class: 'ftc-e__h', text: 'Choose your size' }));
      var chips = el('div', { class: 'ftc-e__chips', role: 'group', 'aria-label': 'Size' });
      var seen = {};
      variants.forEach(function (v) {
        var match = v.options.every(function (o, i) { return i === sizePos - 1 || o === cur.options[i]; });
        var val = v.options[sizePos - 1]; if (!match || seen[val]) return; seen[val] = 1;
        var b = el('button', { type: 'button', class: 'ft-chip', 'aria-pressed': v.id === cur.id ? 'true' : 'false', 'aria-disabled': v.available ? 'false' : 'true', text: val });
        b.addEventListener('click', function () { if (!v.available) return; state.variant = v; chips.querySelectorAll('.ft-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); }); paint(); });
        chips.appendChild(b);
      });
      body.appendChild(chips);
    }

    // các ô custom đang có (theo cấu hình form của sản phẩm)
    var fields = [];
    if (cfg && props._fathom) {
      cfg.fields.forEach(function (f) { if (props[f.label] != null && String(props[f.label]).trim() !== '') fields.push(f); });
    }
    fields.forEach(function (f) {
      state.vals[f.label] = String(props[f.label]);
      var id = 'ftc-e-' + f.key;
      var inp = el('input', { id: id, type: 'text', class: 'ftc-e__in', maxlength: String(f.max || 30), autocomplete: 'off', inputmode: f.kind === 'number' ? 'numeric' : 'text' });
      inp.value = state.vals[f.label];
      inp.addEventListener('input', function () { if (f.kind === 'number') inp.value = inp.value.replace(/[^0-9]/g, ''); state.vals[f.label] = inp.value; paint(); });
      body.appendChild(el('label', { class: 'ftc-e__fld', for: id }, [el('span', {}, [f.label, el('small', { text: ' +' + money(Math.round(f.price * 100)) })]), inp]));
    });
    if (fields.length) body.appendChild(el('p', { class: 'ftc-e__small', text: 'Check spelling. Printed as entered. Clear a field to remove it.' }));
    var logoKeys = Object.keys(props).filter(function (k) { return /^Logo \d+ (placement|file)$/.test(k) && props[k]; });
    if (logoKeys.length) body.appendChild(el('p', { class: 'ftc-e__small', text: 'Your uploaded logo stays as is. To change a logo, remove this item and add it again from the product page.' }));
    if (!fields.length && !logoKeys.length && props._fathom == null) body.appendChild(el('p', { class: 'ftc-e__small', text: 'To add a name or logo, open the product page.' }));

    var sum = el('dl', { class: 'ftc-e__sum' }); body.appendChild(sum);
    var err = el('p', { class: 'ftc__err', role: 'alert', hidden: 'hidden' }); body.appendChild(err);
    var save = el('button', { type: 'button', class: 'ft-btn ft-btn--cta ft-btn--block', text: 'Save changes' });
    var cancel = el('button', { type: 'button', class: 'ft-btn ft-btn--outline ft-btn--block', 'data-ft-close': '', text: 'Cancel' });
    body.appendChild(save); body.appendChild(cancel);
    body.appendChild(el('p', { class: 'ftc-e__small ftc__center', text: 'Updates this item in your cart.' }));

    function feeCents() {
      var t = 0;
      fields.forEach(function (f) { if (String(state.vals[f.label] || '').trim()) t += Math.round(f.price * 100); });
      if (cfg) (cfg.logos || []).forEach(function (l) { if (props[l.label + ' placement'] || props[l.label + ' file']) t += Math.round(l.price * 100); });
      return t;
    }
    function paint() {
      var v = state.variant || cur, fee = feeCents();
      sum.innerHTML = '';
      [[type || 'Item', money(v.price)], fee ? ['Personalization', money(fee)] : null, ['Item total', money(v.price + fee)], ['Quantity', String(qty)]].forEach(function (r) {
        if (!r) return; sum.appendChild(el('div', {}, [el('dt', { text: r[0] }), el('dd', { text: r[1] })]));
      });
    }
    paint();

    save.addEventListener('click', function () {
      if (save.getAttribute('aria-busy')) return;
      var np = {}; Object.keys(props).forEach(function (k) { np[k] = props[k]; });
      fields.forEach(function (f) { var v = String(state.vals[f.label] || '').replace(/\s+/g, ' ').trim(); if (v) np[f.label] = v; else delete np[f.label]; });
      if (np._fathom) {
        try {
          var fm = JSON.parse(np._fathom), keys = [], vals = {};
          (fm.k || []).forEach(function (k) {
            if (np[k] != null && String(np[k]).trim() !== '') { keys.push(k); vals[k] = np[k]; }
            else if (np[k + ' placement'] || np[k + ' file']) { keys.push(k); if (np[k + ' placement']) vals[k + ' placement'] = np[k + ' placement']; }
          });
          if (keys.length) np._fathom = JSON.stringify({ c: fm.c, k: keys, v: vals }); else delete np._fathom;
        } catch (e) {}
      }
      var v = state.variant || cur, key = line.getAttribute('data-ftc-line');
      save.setAttribute('aria-busy', 'true'); save.textContent = 'Saving…'; err.hidden = true;
      var p = v.id === cur.id
        ? post('cart/change.js', { id: key, quantity: qty, properties: np })
        : post('cart/add.js', { items: [{ id: v.id, quantity: qty, properties: np }] }).then(function () {
            // Key dòng cũ có thể đổi sau khi thêm: đọc lại giỏ, tìm dòng cũ theo key, rồi theo biến thể + thuộc tính gốc; xoá theo số thứ tự dòng.
            return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
              var items = cart.items || [], same = JSON.stringify(props), idx = -1;
              items.forEach(function (i, n) { if (idx < 0 && i.key === key) idx = n; });
              if (idx < 0) items.forEach(function (i, n) { if (idx < 0 && i.variant_id === cur.id && JSON.stringify(i.properties || {}) === same) idx = n; });
              if (idx < 0) throw new Error('Your new choice was added, but the old item is still in your cart. Please remove it.');
              return post('cart/change.js', { line: idx + 1, quantity: 0 });
            });
          });
      p.then(function () { location.reload(); }).catch(function (x) {
        save.removeAttribute('aria-busy'); save.textContent = 'Save changes';
        err.hidden = false; err.textContent = (x && x.message) || 'Could not save. Your cart was not changed.';
      });
    });
    window.FtSheet.open(sheet, opener);
  };

  window.FtCart = FtCart;
  function init() { document.querySelectorAll('[data-ftc]:not([data-ftc-ready])').forEach(function (r) { r.setAttribute('data-ftc-ready', '1'); try { new FtCart(r); } catch (e) { console.error('FtCart', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
